import { render, staticRenderFns } from "./SendPurchaseOrderArtworks.vue?vue&type=template&id=b29f3a0c"
import script from "./SendPurchaseOrderArtworks.vue?vue&type=script&lang=js"
export * from "./SendPurchaseOrderArtworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b29f3a0c')) {
      api.createRecord('b29f3a0c', component.options)
    } else {
      api.reload('b29f3a0c', component.options)
    }
    module.hot.accept("./SendPurchaseOrderArtworks.vue?vue&type=template&id=b29f3a0c", function () {
      api.rerender('b29f3a0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Application/Orders/SendPurchaseOrderArtworks.vue"
export default component.exports